/**
 * @generated SignedSource<<3f42a5d85016fb5ec16708f41a434776>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TalentAvailability = "AVAILABLE" | "BOOKED" | "UNAVAILABLE" | "%future added value";
export type TalentRole = "COLORIST" | "DIRECTOR" | "DRONE_PILOT" | "EDITOR" | "PHOTOGRAPHER" | "PRODUCER" | "SOUND_ENGINEER" | "VIDEOGRAPHER" | "%future added value";
export type CreateTalentProfileInput = {
  availability?: TalentAvailability | null | undefined;
  bio?: string | null | undefined;
  clientMutationId?: string | null | undefined;
  dayRate?: number | null | undefined;
  facebookPageUrl?: string | null | undefined;
  facebookProfileUrl?: string | null | undefined;
  featured?: boolean | null | undefined;
  headline?: string | null | undefined;
  hourRate?: number | null | undefined;
  imageUrl?: string | null | undefined;
  name?: string | null | undefined;
  portfolioLinks?: ReadonlyArray<PortfolioLinkInput> | null | undefined;
  position?: number | null | undefined;
  published?: boolean | null | undefined;
  roles?: ReadonlyArray<TalentRole> | null | undefined;
  skills?: ReadonlyArray<string> | null | undefined;
  slug?: string | null | undefined;
};
export type PortfolioLinkInput = {
  label?: string | null | undefined;
  url: string;
};
export type OpsTalentEditPageCreateMutation$variables = {
  input: CreateTalentProfileInput;
};
export type OpsTalentEditPageCreateMutation$data = {
  readonly createTalentProfile: {
    readonly talentProfile: {
      readonly id: string;
    } | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly message: string;
    }>;
  } | null | undefined;
};
export type OpsTalentEditPageCreateMutation = {
  response: OpsTalentEditPageCreateMutation$data;
  variables: OpsTalentEditPageCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateTalentProfilePayload",
    "kind": "LinkedField",
    "name": "createTalentProfile",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TalentProfile",
        "kind": "LinkedField",
        "name": "talentProfile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "userErrors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OpsTalentEditPageCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OpsTalentEditPageCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "09fd0ac91ec25ca97d60b00e34799a1d",
    "id": null,
    "metadata": {},
    "name": "OpsTalentEditPageCreateMutation",
    "operationKind": "mutation",
    "text": "mutation OpsTalentEditPageCreateMutation(\n  $input: CreateTalentProfileInput!\n) {\n  createTalentProfile(input: $input) {\n    talentProfile {\n      id\n    }\n    userErrors {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9fe1ebd06bb1f548a8c2d08d64b5a30a";

export default node;
